export default __webpack_public_path__ + "static/media/starter.507a5f41.mp3";